// extracted by mini-css-extract-plugin
module.exports = {"tableDisplay":"styles_tableDisplay__bXZgo"};